import "layouts/Home/Home.css";
import React from "react";
import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import {Link} from "react-router-dom";
import localization from "../../../config/localization";
import styled from "styled-components";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideMenu: "close",
      height: "0%",
    };
  }

  render() {
    return (
      <footer style={{padding: 0}}>
        <div style={{
          padding: "0.55rem 0 0.625rem",
          backgroundColor: "#1E1E1E",
          position: "relative",
          float: "left",
          width: "100%"}}
        >
          <div style={{position: "relative",float: "left", padding: "0px 70px", width: "100%"}}>
            <MobileDiv>
              <h6 style={{ marginRight: 20}}>
                <small>© 2019 Bloomclouds</small>
              </h6>
              <FooterDocumentLink
                requestRoute={`${process.env.REACT_APP_API_HOST}/documents/privacyPolicy/download?locale=${localization.getLanguage()}`}
                title={localization.get('footer.privacy_policy')}
              />
              <FooterDocumentLink
                requestRoute={`${process.env.REACT_APP_API_HOST}/documents/termsOfUse/download?locale=${localization.getLanguage()}`}
                title={localization.get('footer.term_of_use')}
              />
            </MobileDiv>
            <div style={{position: "relative", float: "right", marginTop: 8}}>
              {/*<span className="footer-span" style={{marginTop: 2, float: "left"}}>Powered by </span>*/}
              {/*<img className="navbar-image" style={{filter: "brightness(0) invert(1)",float: "left", opacity: "0.3", height: "20px", width: 85}} src={LogoWhite} alt="Logo" />*/}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const FooterDocumentLink = withStyles({
  title: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
})(({ classes, requestRoute, title }) => {
  return (
    <Link to={requestRoute} target="_blank">
      <h6 style={{ marginRight: 20 }}>
        <small className={classes.title}>
          {title}
        </small>
      </h6>
    </Link>
  );
});

export default withStyles(pagesStyle)(Footer);

const MobileDiv = styled.div`
display: inline-flex;
align-self: center;
  @media(max-width: 500px){
  justify-self: center;
  }
`;

const MobileUl = styled.ul`
margin: -5px;
place-self: end;
  @media(max-width: 500px){
  place-self: center;
  }
`;
